import React, { useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import Title from 'components/Title'
import AccountManagerList from 'components/Table/BasicTable'
import {  message } from 'antd';
import { DataGetAction} from 'redux/actions/http';
import { useDispatch, useSelector } from 'react-redux'
import IntlMessages from 'util/IntlMessages'
import {useLocation} from "react-router-dom";

const Index = () => {

    const dispatch = useDispatch()

    const params = useLocation(); 


    console.log('==============params==========',params)
    const fetchTableData = () => {
        dispatch(DataGetAction('getAllManager', { corporateUserId: params.state._id }, 'gettingAllManager'));
    }
    useEffect(fetchTableData, [params])

    const usersProps = useSelector(state => state.users)
    const {  textMessage, error,allManagersSpinner,allManagers } = usersProps


    let fullName = allManagers && allManagers.length > 0 && allManagers[0].fullName;

    const columns = [
        {
            title: <IntlMessages id="accountManager.id" />,
            render: record => <span>{record.userId}</span>,
            key: "userId"
        },
        {
            title: <IntlMessages id="accountManager.fullName" />,
            render: record => <span>{record.fullName}</span>,
            key: "firstName"
        },
        {
            title: <IntlMessages id="accountManager.email" />,
            render: record => <span>{record.email}</span>,
            key: "email"
        },
        {
            title: <IntlMessages id="accountManager.phone" />,
            render: record => <span>{record.phoneNumber}</span>,
            key: "phone"
        },
       
        
    ]






    // const data = [{
    //     userId: 1,
    //     _id: 1,
    //     fullName: 'umar',
    //     companyName: 'company A',
    //     email: 'a@g.com',
    //     phoneNumber: '121243',
    //     corporateAccount: 'company A',
    // }]








    if (error) {
        message.error(textMessage)
        dispatch({
            type: "reset_corporateAccount_States"
        })
    }

    const styles ={
        subTitle : {
            marginLeft: '8px',
            verticalAlign: 'sub',
            marginTop: '7px',
            display: 'inline-block'
        }
    }

    return (
        <Layout>
            <div className="gx-d-block gx-flex-row gx-justify-content-between">
                <div className="gx-d-flex gx-flex-row">
                    <div className="gx-mb-2 gx-mb-md-0">
                        <Title title="Account Managers" />
                        <span style={styles.subTitle}>({fullName && fullName})</span>
                    </div>



                </div>

                {/* <div className="gx-d-flex">
                    <div className="gx-my-0 gx-mx-md-3 gx-mx-0" style={{ width: '200px' }}>
                        <Input.Search
                            showSearch
                            placeholder="ID/Email/Name"
                            filterOption={false}
                            onChange={(e) => dispatch(DataGetAction('getCorporateAccounts', { name: e.target.value }, ''))}

                        />
                    </div>
                </div> */}
            </div>
            <AccountManagerList loading={allManagersSpinner} data={ allManagersSpinner ? [] :  allManagers} columns={columns} />
            
        </Layout >
    )
}

export default Index
